let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eOXxt")).then(() => parcelRequire('6qyMq'));